export var SocialNetworks;
(function (SocialNetworks) {
    SocialNetworks[SocialNetworks["Facebook"] = 0] = "Facebook";
    SocialNetworks[SocialNetworks["Twitter"] = 1] = "Twitter";
    SocialNetworks[SocialNetworks["LinkedIn"] = 2] = "LinkedIn";
})(SocialNetworks || (SocialNetworks = {}));
//# sourceMappingURL=social-networks.js.map